import { Component } from '@angular/core';
import { EregistrationsTranslationService } from '../../../services/eregistrations-translation.service';

@Component({
  selector: 'app-language-menu',
  templateUrl: './language-menu.component.html'
})
export class LanguageMenuComponent {
  constructor(
    public eregistrationsTranslationService: EregistrationsTranslationService
  ) {}

  getLanguageCodeTranslation(value: string): string {
    switch (value) {
      case 'et':
        return $localize`:@@et:et`;
      case 'en':
        return $localize`:@@en:en`;
      case 'fr':
        return $localize`:@@fr:fr`;
      case 'es':
        return $localize`:@@es:es`;
      case 'ar':
        return $localize`:@@ar:ar`;
    }

    return value;
  }
}
